export function supportsFileSystemAccess() {
  return typeof window !== 'undefined' && 'showOpenFilePicker' in window && 'showDirectoryPicker' in window;
}

export async function openJsonWithHandle() {
  if (!('showOpenFilePicker' in window)) return null;
  const [handle] = await window.showOpenFilePicker({
    multiple: false,
    types: [{ description: 'JSON files', accept: { 'application/json': ['.json'] } }],
  });
  const file = await handle.getFile();
  const text = await file.text();
  return { handle, fileName: file.name, data: JSON.parse(text) };
}

export async function readJsonFile(file) {
  return JSON.parse(await file.text());
}

export async function saveJsonToHandle(handle, data) {
  if (!handle) throw new Error('원본 파일 핸들이 없습니다.');
  const permission = await handle.requestPermission?.({ mode: 'readwrite' });
  if (permission && permission !== 'granted') throw new Error('파일 쓰기 권한이 허용되지 않았습니다.');
  const writable = await handle.createWritable();
  await writable.write(JSON.stringify(data, null, 2));
  await writable.close();
}

export function downloadJson(data, fileName = 'parsed_gems.json') {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function chooseImageDirectory() {
  if (!('showDirectoryPicker' in window)) return null;
  return window.showDirectoryPicker({ mode: 'read' });
}

export function filesToNameMap(fileList) {
  const map = new Map();
  for (const file of fileList ?? []) map.set(file.name, file);
  return map;
}

export async function tryDeleteImage(directoryHandle, fileName) {
  if (!directoryHandle || !fileName) return false;
  try {
    const permission = await directoryHandle.requestPermission?.({ mode: 'readwrite' });
    if (permission && permission !== 'granted') return false;
    await directoryHandle.removeEntry(fileName);
    return true;
  } catch {
    return false;
  }
}
